import { createSlice } from '@reduxjs/toolkit';
import {
  initContentCreate,
  IContentCreate,
  getUnitid,
  flatUnitEnter,
} from './createProduct-data';

function flatProductEngineList(list: IContentCreate['productEngineList']) {
  const boxlist: IContentCreate['productEngineList'] = [];

  function doFlat(
    targetList: IContentCreate['productEngineList'],
    containerList: IContentCreate['productEngineList']
  ) {
    targetList.forEach((item) => {
      const { children, ...rest } = item;
      containerList.push(rest);

      if (children) {
        doFlat(children, containerList);
      }
    });
  }

  doFlat(list, boxlist);

  return boxlist;
}

const createProductSlice = createSlice({
  name: 'createProduct',
  initialState: initContentCreate,
  reducers: {
    setBookData: (state, action) => {
      const data = action.payload as IContentCreate['bookData'];
      const chapter_info = data.chapter_info;
      const flatChater = flatUnitEnter(data.chapter_info);
      const unitid = getUnitid(chapter_info[0]);
      if (!state.unitid) {
        state.unitid = unitid;
      }
      state.bookData = data;
      state.flatChater = flatChater;
    },
    setUnitid: (state, action) => {
      const unitid = action.payload as string;
      state.unitid = unitid;
    },
    setActiveGrounp: (state, action) => {
      const activeGrounp = action.payload as IContentCreate['activeGrounp'];
      state.activeGrounp = activeGrounp;
    },
    setActiveGrounpChild: (state, action) => {
      const activeGrounpChild =
        action.payload as IContentCreate['activeGrounpChild'];
      state.activeGrounpChild = activeGrounpChild;
    },
    setBookList: (state, action) => {
      state.bookList = action.payload;
    },
    setActiveAgentInfo: (state, action) => {
      state.activeAgentInfo = action.payload;
    },
    setTemplateGroups: (state, action) => {
      state.templateGroups = action.payload;
    },

    setShuxingChangedFlag: (state, action) => {
      state.shuxingChangedFlag = action.payload;
    },
    setProductEngineList: (state, action) => {
      const payload = action.payload as IContentCreate['productEngineList'];
      const flatList = flatProductEngineList(payload);
      state.productEngineList = payload;
      state.flatProductEngineList = flatList;
    },
    setTemList: (state, action) => {
      state.temList = action.payload;
    },
    togglePreviewFreshFlag: (state, action) => {
      state.previewFreshFlag = !state.previewFreshFlag;
    },
    toggleFreshPublishFlag: (state, action) => {
      state.freshPublishFlag = !state.freshPublishFlag;
    },
  },
});

export const {
  setBookData,
  setBookList,
  setUnitid,
  setActiveGrounp,
  setActiveGrounpChild,
  setActiveAgentInfo,
  setTemplateGroups,
  setShuxingChangedFlag,
  setProductEngineList,
  togglePreviewFreshFlag,
  toggleFreshPublishFlag,
  setTemList,
} = createProductSlice.actions;
export default createProductSlice.reducer;
